
import { Component, OnInit, inject, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavItem } from '../../models/nav-item.model';
import { AuthService } from '../../../core/services/auth.service';
import { UserRole,UserRoleIdMap } from '../../models/user.model';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, MatIconModule,TranslateModule, RouterModule, MatExpansionModule],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  @Input() isMobileOrTablet = false;
  @Output() closeSidenav = new EventEmitter<void>();
 
  navItems: NavItem[] = [];
  currentUrl = '';
    private translate = inject(TranslateService);
  
  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    // sidenav close for mobile/tablet on route change
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && this.closeSidenav) {
        this.closeSidenav.emit();
      }
    });
    
    // Define all navigation items with their allowed roles
    const allNavItems: NavItem[] = [
        {
          name: 'Dashboard',
          headerIcon: 'assets/images/dashboard.svg',
          route: '/dashboard',
          allowedRoles: [
            UserRole.Super_Admin, 
            UserRole.App_Admin, 
            UserRole.DME_Admin,
            UserRole.DME_User, 
            UserRole.Patient
          ]
        },
        {
          name: 'Devices',
          headerIcon: 'assets/images/devices.svg',
          children: [
            {
              name: 'Concentrators',
              route: '/concentrators',
              headerIcon: 'assets/images/Con_menu.png',
              allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_Admin, UserRole.DME_User, UserRole.Patient]
            },
         ],
          allowedRoles: [
            UserRole.DME_Admin,
            UserRole.DME_User,
            UserRole.Patient
          ]
        },
        {
          name: 'Device Alerts',
          headerIcon: 'assets/images/device_Alerts.svg',
          route: '/device-alerts',
          allowedRoles: [
            UserRole.DME_Admin,
            UserRole.DME_User,
          ]
        },
        {
          name: 'CAIRE Network',
          headerIcon: 'assets/images/network.svg',
          children: [
            {
              name: 'Organizations (DMEs)',
              route: '/organizations',
              headerIcon: 'assets/images/network.svg',
              allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin]
            },
            // {
            //   name: this.translate.instant('sideNav.patients'),
            //   route: '/patients',
            //   headerIcon: 'assets/images/person_heart.svg',
            //   allowedRoles: [UserRole.Super_Admin]
            // }
          ],
          allowedRoles: [
            UserRole.Super_Admin,
            UserRole.App_Admin
          ]
        },
         {
          name: 'My Network',
          headerIcon: 'assets/images/network.svg',
          children: [
            {
              name: 'Service Centers',
              route: '/serviceCenters',
              headerIcon: 'assets/images/service_centers.svg',
              allowedRoles: [UserRole.DME_Admin]
            },
            {
              name: 'Patients',
              route: '/patients',
              headerIcon: 'assets/images/person_heart.svg',
              allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient]
            }
          ],
          allowedRoles: [
            UserRole.DME_Admin,
          ]
        },
        {
          name: 'Patients',
          headerIcon: 'assets/images/person_heart.svg',
          route: '/patients',
          allowedRoles: [
            UserRole.DME_User, 
            UserRole.Patient,

          ]
        },
        {
          name: 'Service Requests',
          headerIcon: 'assets/images/headphone.svg',
          route: '/serviceRequests',
          children: [
            // { name: 'Patients', route: '/patients', allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient] },
            // { name: 'Users', route: '/people/users', allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient] }
          ],
          allowedRoles: [
            UserRole.DME_Admin,
            UserRole.DME_User,
          ]
        },
        {
          name: 'User Management',
          headerIcon: 'assets/images/people.svg',
          route: '/userManagement',
          children: [
            // { name: 'Patients', route: '/patients', allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient] },
            // { name: 'Users', route: '/people/users', allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient] }
          ],
          allowedRoles: [
            UserRole.Super_Admin,
            UserRole.App_Admin,
            UserRole.DME_Admin,
          ]
        },
        {
          name: 'Audit Logs',
          headerIcon: 'assets/images/audit_logs.svg',
          route: '/auditLogs',
          children: [
            // { name: this.translate.instant('sideNav.patients'), route: '/patients', allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient] },
            // { name: this.translate.instant('sideNav.users'), route: '/people/users', allowedRoles: [UserRole.Super_Admin, UserRole.App_Admin, UserRole.DME_User, UserRole.Patient] }
          ],
          allowedRoles: [
            UserRole.Super_Admin,
            UserRole.App_Admin,
            UserRole.DME_Admin,
          ]
        },
      ];
    
    // Filter items based on user's role
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      const roleEntry = Object.entries(UserRoleIdMap).find(([, id]) => id === Number(currentUser?.roleId));
      if (roleEntry && currentUser) {
        currentUser.role = roleEntry[0] as UserRole;
      }
      this.navItems = allNavItems.filter(item => 
        item.allowedRoles.includes(currentUser.role)
      );
    }
    
    // Track current URL for active route highlighting
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = event.url;
    });
  }
 
   // Helper method to check if a route is active (for highlighting)
  isChildRouteActive(item: any): boolean {
    const normalize = (url: string) => url ? url.replace(/\/+$/, '') : '';
    if (item.route) {
      return (
        normalize(this.currentUrl) === normalize(item.route) ||
        normalize(this.currentUrl).startsWith(normalize(item.route) + '/')
      );
    }
    if (item.children) {
      return item.children.some((child: any) =>
        normalize(this.currentUrl) === normalize(child.route) ||
        normalize(this.currentUrl).startsWith(normalize(child.route) + '/')
      );
    }
    return false;
  }
  
}